import React, { useEffect, useRef } from 'react';
import { FormulaBlock } from '../../ast/document.types';
import { renderSmartKatex } from '../../ast/smartLatex';

interface FormulaBlockRendererProps {
  block: FormulaBlock;
}

export const FormulaBlockRenderer: React.FC<FormulaBlockRendererProps> = ({ block }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { latex, displayMode = true, caption, equationNumber, fontSizePt, alignment = 'center', offsetX = 0, offsetY = 0 } = block.data;

  useEffect(() => {
    if (containerRef.current) {
      renderSmartKatex(latex || 'x = 0', containerRef.current, { displayMode });
    }
  }, [latex, displayMode]);

  return (
    <div
      className="doc-formula-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: alignment === 'left' ? 'flex-start' : alignment === 'right' ? 'flex-end' : 'center',
        margin: '12px 0',
        padding: '6px 12px',
        borderRadius: 'var(--radius-sm)',
        position: 'relative',
        fontSize: fontSizePt ? `${fontSizePt}pt` : undefined,
        transform: `translate(${offsetX}px, ${offsetY}px)`,
        transition: 'transform 0.05s ease-out',
      }}
    >
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ flex: 1, textAlign: displayMode ? 'center' : 'left' }}>
          <div ref={containerRef} className="katex-rendered-block" />
        </div>
        {equationNumber && (
          <span
            style={{
              fontSize: '11px',
              fontStyle: 'italic',
              color: '#6b7280',
              marginLeft: '12px',
              userSelect: 'none',
            }}
          >
            {equationNumber}
          </span>
        )}
      </div>

      {caption && (
        <div
          style={{
            fontSize: '11px',
            color: '#6b7280',
            fontStyle: 'italic',
            marginTop: '4px',
            textAlign: 'center',
          }}
        >
          {caption}
        </div>
      )}
    </div>
  );
};
